import { RemoveCircle } from '@mui/icons-material';
import { Button } from '@mui/material';
import {useState} from "react";
import AddButton from "../../../UserScreen/InventoryPage/InventorySettings/components/AddButton/AddButton";
import LabelValueDisplay from "../../../UserScreen/InventoryPage/InventorySettings/components/LabelValue/LabelValueDisplay";
import OrgSelection from "../../OrgSelection";
import DP_Dropdown from "../../InventoryWarehouseTable/DP_Dropdown";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const ServiceAccountClients = (props) => {
    const {serviceAccountClients, setServiceAccountClients, disableActions, selectedOu} = props;

    const addNewClient = () => {
        const newClient = {
            id: serviceAccountClients.length,
            clientId: "",
            clientSecret: "",
            accountNumber: "",
            selectedDp: { id: selectedOu?.id, name: selectedOu?.name }
        }
        setServiceAccountClients([...serviceAccountClients, newClient])
    }
    const updateClients = (id, updatedAction) => {
        setServiceAccountClients(
            serviceAccountClients.map((action, index) =>
                index === id ? updatedAction : action
            )
        );
    }
    const removeClient = (id: string) => {
        const updatedActions = serviceAccountClients.filter((_, index) => index !== id);
        setServiceAccountClients(updatedActions);

        setServiceAccountClients((prevActions) =>
            prevActions.map((action, index) => ({ ...action, id: index }))
        );
    }
    return(
        <div>
            <div>
                {serviceAccountClients.map((action, index) => (
                    <ServiceAccountClient
                        key={index}
                        id={index}
                        data={action}
                        onUpdate={updateClients}
                        onRemove={removeClient}
                        disableActions={disableActions}
                    />
                ))}
            </div>
            <AddButton onAddClick={addNewClient} addLabel={"+"} maxWidth={'64px'}/>
            {/* <Button variant="outlined" size="small" startIcon={<AddCircle id="addActionIcon"/>} id="threatKontrolAddAction" onClick={addNewClient} >
                    Add Action
            </Button> */}
        </div>
    )

} 

const ServiceAccountClient = (props) => {
    const {id,  data, onUpdate, onRemove, disableActions} = props;
    const handleChange = (field, e) => {
        onUpdate(id, { ...data, [field]: e.target.value || '' });
    };
    const handleOrgChange= (value) => {
        onUpdate(id, { ...data, ['selectedDp']: value || null });
    }
    return(
        <div className="displayClients">
            <div className='width35'>
                {/* <OrgSelection value={data.selectedDp} onChange={(e) => handleChange('selectedDp', e)} disabled={disableActions} /> */}
                {/* <LabelValueDisplay
                    label={"Sub Org"}
                    isInput={true}
                    value={data.selectedDp}
                    onChange={(e) => handleChange('clientId', e)}
                /> */}
                <LabelValueDisplay
                  label="Organization"
                  customComponent={
                    <div style={{ width: '100%', maxWidth: '438px' }}>
                      <OrgSelection value={data.selectedDp} onChange={(value) => handleOrgChange( value)} disabled={disableActions} height={28}/>
                    </div>
                  }
                />
            </div>
            <div className="width21">
                <LabelValueDisplay
                    label={"Account Number"}
                    isInput={true}
                    value={data.accountNumber}
                    onChange={(e) => handleChange('accountNumber', e)}
                />
            </div>
            <div className="width25">
                <LabelValueDisplay
                    label={"Client ID"}
                    isInput={true}
                    value={data.clientId}
                    onChange={(e) => handleChange('clientId', e)}
                />
            </div>
            <div className="width19">
                <LabelValueDisplay
                    label={"Client Secret"}
                    type={"password"}
                    isInput={true}
                    value={data.clientSecret}
                    onChange={(e) => handleChange('clientSecret', e)}
                />
            </div>
            <RemoveCircle className="clientRemoveIcon" onClick={() => onRemove(id)}/>
        </div>
    )
}
const mapStateToProps = (state: any) => ({
    selectedOu: state.authReducer.selectedOu,
});

export default withRouter(
    connect(mapStateToProps, {
    })(ServiceAccountClients)
);